import React from 'react';
import { Button, Notification } from '@codeparva/ui-components-library';
import { Form, Formik } from 'formik';
import { updateAccountFormSchema } from '../../formValidationSchema';
import { AccountSettingsTypes } from '../../AccountSettingsTypes';
import { MyTextField } from './AccountSettingFormFeilds';
export const UpdateAccountNameForm = ({
  AccountNameUpdate,
  ledgerId,
  ledgerName,
}: AccountSettingsTypes.TUpdateAccountName) => {
  const [notification, setNotification] = React.useState(false);
  const [isSubmitting, setSubmitting] = React.useState(false);
  return (
    <>
      <Formik
        initialValues={{
          accountName: ledgerName,
        }}
        validationSchema={updateAccountFormSchema}
        onSubmit={(values, { resetForm }) => {
          setSubmitting(true);
          AccountNameUpdate(
            values.accountName,
            setNotification,
            ledgerId,
            setSubmitting,
            resetForm
          );
        }}
      >
        {({ dirty, isValid }) => (
          <div className="accountSettingsForm">
            <div className="cardInfoContainer">
              <Form>
                <div className="cardNumberSection">
                  {notification ? (
                    <div className="notificationSection">
                      <Notification className="notificationColor">
                        Account Name has been updated successfully.
                        <button
                          className="delete"
                          onClick={() => setNotification(false)}
                        ></button>
                      </Notification>
                    </div>
                  ) : (
                    <></>
                  )}
                  <MyTextField
                    label="Name"
                    type="text"
                    name="accountName"
                    placeholder="Name"
                  />
                </div>
                <div className="btnContainer">
                  <Button
                    className={`cp-primary-button-highlighted ${
                      isSubmitting ? 'is-loading' : ''
                    }`}
                    disabled={!dirty || !isValid}
                  >
                    Update Details
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};
